import React from "react";

import { Input } from "clearsense-ui/components/formik";

const DatabaseDetails = ({ databaseDetails, setFieldValue, handleChange }) => (
  <div className="flex flex-col space-y-4">
    <Input
      label="Host Name"
      name="db_host"
      placeholder="Host Name"
      value={databaseDetails.db_host}
      onChange={e => handleChange(e.target.name, e.target.value, setFieldValue)}
    />
    <Input
      label="Port"
      name="db_port"
      placeholder="Port"
      value={databaseDetails.db_port}
      onChange={e => handleChange(e.target.name, e.target.value, setFieldValue)}
    />
    <Input
      label="Database Name"
      name="db_name"
      placeholder="Database Name"
      value={databaseDetails.db_name}
      onChange={e => handleChange(e.target.name, e.target.value, setFieldValue)}
    />
    <Input
      label="Database Username"
      name="db_user"
      placeholder="Database Username"
      value={databaseDetails.db_user}
      onChange={e => handleChange(e.target.name, e.target.value, setFieldValue)}
    />
    <Input
      label="Database Password"
      name="db_pass"
      placeholder="Database Password"
      value={databaseDetails.db_pass}
      onChange={e => handleChange(e.target.name, e.target.value, setFieldValue)}
    />
    <Input
      label="Database Schema"
      name="db_schema"
      placeholder="Database Schema"
      value={databaseDetails.db_schema}
      onChange={e => handleChange(e.target.name, e.target.value, setFieldValue)}
    />
  </div>
);

export default DatabaseDetails;
